import { StylesContext } from "@material-ui/styles"
import styled from "styled-components"
import React from "react"

const Container = styled("div")`
    width: 100vw;
    height: 150 px;
    background-color: cyan;
    margin: 25px; 
    justify-content: center;

    padding: 10 px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const ListItem = styled("li")`
    margin: 10px;  
`
 
const FAQ = () => {
    return (
        <Container>

        <h2>BUFF MUSCLES ROADMAP</h2>

        <ul style={{padding: '0px 25%'}}>
        
        We have a couple projects coming up in the wings, and holders of these genesis Buff Muscles will be entitled to whitelists, airdrops, and early news about upcoming projects.
        </ul>

        </Container>

    )
}

export default FAQ;